import spacingToPx from "./spacingToPx";

export default spacingToPx;
